import React, { useEffect, useState, useCallback } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import DataTable from 'react-data-table-component';
import TabelaLoading from '../../components/TabelaLoading';
import TabelaVazia from '../../components/TabelaVazia';
import IconButton from '../../components/IconButton';
import NavItem from '../../components/NavItem';
import { FaPen, FaPlus, FaTrash, FaSearch, FaCog } from 'react-icons/fa';
import api from '../../services/api';
import { toast } from 'react-toastify';

export default function PainelOrcamentoModelo() {
    const token = localStorage.getItem('token');
    const [filtro, setFiltro] = useState({ nome: '' });
    const [lista, setLista] = useState([]);
    const [buscando, setBuscando] = useState(false);

    const buscar = useCallback(() => {

        setBuscando(true);
        api({ method: 'get', action: '/orcamentoModelo', token, params: filtro })
            .then(resp => setLista(resp.data.data))
            .catch(() => toast.error('Erro ao buscar modelos'))
            .finally(() => setBuscando(false));
    }, [token, filtro]);

    const excluir = (id) => {
        api({ method: 'delete', action: `/orcamentoModelo/${id}`, token })
            .then(() => { toast.success('Modelo excluído'); buscar(); })
            .catch(() => toast.error('Erro ao excluir modelo'));
    };

    useEffect(() => { buscar(); }, [buscar]);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <ul className="nav">
                    <NavItem to="/cadastroOrcamentoModelo" icon={<FaPlus size={20} />} color="primary">Novo Modelo</NavItem>
                    <NavItem to="/configuracaoOrcamentoModelo" icon={<FaCog size={20} />} color="secondary">Configurações</NavItem>
                </ul>
                <div className="page-title">
                    <h3>Modelos de Orçamento</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label>Nome do Modelo</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={filtro.nome}
                                                            onChange={(e) => setFiltro({ ...filtro, nome: e.target.value })}
                                                            placeholder="Digite o nome do modelo"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1">
                                                        <FaSearch size={20} /> Buscar</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="row mb-4">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body px-0 pb-0">
                                    <div className="table-responsive">
                                        <DataTable
                                            progressPending={buscando}
                                            persistTableHead
                                            progressComponent={<TabelaLoading />}
                                            noDataComponent={<TabelaVazia />}
                                            pagination
                                            paginationComponentOptions={{ rowsPerPageText: 'Linhas', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }}
                                            className="table mb-0"
                                            columns={[
                                                {
                                                    name: 'Ações',
                                                    cell: (row) => (
                                                        <>
                                                            <IconButton small={true} to={`/cadastroOrcamentoModelo/${row.id}`} icon={<FaPen size={16} />} color="primary">Editar</IconButton>
                                                            <IconButton small={true} onClick={() => excluir(row.id)} icon={<FaTrash size={16} />} color="warning">Excluir</IconButton>
                                                        </>
                                                    ),
                                                    width: '180px'
                                                },
                                                {
                                                    name: 'Nome',
                                                    selector: r => r.nome,
                                                    sortable: true,
                                                    cell: (row) => row.nome
                                                },
                                            ]}
                                            data={lista}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}


